export default __webpack_public_path__ + "static/media/hamro-logo.a5955f51.png";